import { styled } from '@mui/material';
import { Grid } from '@mui/system';
import { DatePicker } from '@mui/x-date-pickers';

// Styled components
export const FullWidthDatePicker = styled(DatePicker)(({ theme }) => ({
  width: '100%',
  '& .MuiInputBase-root': {
    width: '50%',
  },
}));

export const MarginTopGrid = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(3),
}));